import React, { useEffect, useState, useMemo } from 'react';
import Udesk from 'Udesk';
import { Form, Input, Radio, Button, Space } from 'udesk-ui';
import { UserTagsSelect } from 'Component/pages/components/coach/UserTagsSelect-v2';
import { postIntelligentPartnerCustomerPersonasManageRoleAdd } from 'src/api/intelligentPartnerCustomerPersonas/manage/roleAdd';
import { IntelligentPartnerTagGroupFoundResponse } from 'src/api/types';
import { putIntelligentPartnerCustomerPersonasById } from 'src/api/intelligentPartnerCustomerPersonas/{id}';
import UdeskLocales from 'UdeskLocales';

const CreateRole: React.FC<any> = ({ history, match, location }) => {
    const [form] = Form.useForm<any>();
    const [loading, setLoading] = useState(false);
    const isEdit = Boolean(match?.params?.id);
    const [robotTimbre, setRobotTimbre] = useState<any>(1);
    const [originalNodes, setOriginalNodes] = useState<IntelligentPartnerTagGroupFoundResponse[]>(
        []
    );
    const VOICE = [
        {
            label: /* 艾夏（自然） */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                .edit.aishaNature,
            value: 'aixia',
            robotTimbre: 0,
        },
        {
            label: /* 知莎（聊天） */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                .edit.zhishachat,
            value: 'zhistella',
            robotTimbre: 0,
        },
        {
            label: /* 知倩（温和） */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                .edit.zhiqianGentle,
            value: 'zhiqian',
            robotTimbre: 0,
        },
        {
            label: /* 知米（情感） */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                .edit.knowRiceemotion,
            value: 'zhimi_emo',
            robotTimbre: 0,
        },
        {
            label: /* 艾硕（自然） */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                .edit.aishuoNature,
            value: 'aishuo',
            robotTimbre: 1,
        },
        {
            label: /* 知硕（聊天） */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                .edit.zhishuochat,
            value: 'zhishuo',
            robotTimbre: 1,
        },
        {
            label: /* 艾浩（亲和） */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                .edit.aiHaoAffinity,
            value: 'aihao',
            robotTimbre: 1,
        },
        {
            label: /* 知祥（情感） */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                .edit.zhixiangEmotion,
            value: 'zhixiang',
            robotTimbre: 1,
        },
    ];

    const robotTimbreConfig = useMemo(() => {
        return VOICE.filter((v) => v.robotTimbre === robotTimbre) || [];
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [robotTimbre]);
    // 提交表单
    const handleSubmit = async (values) => {
        setLoading(true);
        console.log('Form values:', values);
        if (isEdit) {
            putIntelligentPartnerCustomerPersonasById(
                {
                    ...values,
                    customerTags: originalNodes,
                },
                {
                    segments: {
                        id: match.params.id,
                    },
                }
            )
                .then((res) => {
                    console.log('res', res);
                    Udesk.ui.notify.success(
                        /* 编辑角色成功 */ UdeskLocales['current'].pages.coach.templateManage
                            .roleManage.edit.editingRoleSuccessfully
                    );
                    history.goBack();
                })
                .finally(() => {
                    setLoading(false);
                });
        } else {
            postIntelligentPartnerCustomerPersonasManageRoleAdd({
                ...values,
                customerTags: JSON.stringify(originalNodes),
            })
                .then((res) => {
                    console.log('res', res);
                    Udesk.ui.notify.success(
                        /* 创建角色成功 */ UdeskLocales['current'].pages.coach.templateManage
                            .roleManage.edit.roleCreatedSuccessfully
                    );
                    history.goBack();
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    const handleOriginalNodes = (originalNodes: IntelligentPartnerTagGroupFoundResponse[]) => {
        console.log('originalNodes', originalNodes);
        setOriginalNodes(originalNodes);
    };

    // 取消
    const handleCancel = () => {
        history.goBack();
    };

    const fetchSceneDetail = async () => {
        setLoading(true);
        try {
            // 优先使用 location.state 中的数据
            if (location.state?.record) {
                const record = location.state.record;
                // 处理 customerTags，只获取子元素的 id
                const customerTagIds = record.customerTags
                    ? record.customerTags
                          .flatMap((group) => group.tags?.map((tag) => tag.id))
                          .filter(Boolean)
                    : [];

                form.setFieldsValue({
                    createType: 'precise',
                    name: record.name,
                    robotTimbre: record.robotTimbre,
                    robotTimbreConfig: record?.robotTimbreConfig,
                    desc: record.desc,
                    customerTags: customerTagIds, // 设置处理后的标签 ID 数组
                    remark: record.remark,
                });
                setRobotTimbre(record.robotTimbre);
                // 保存原始节点数据，用于提交时重构
                setOriginalNodes(record.customerTags || []);
                setLoading(false);
                return;
            }
        } catch (error) {
            Udesk.ui.notify.error(
                /* 获取场景详情失败 */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                    .edit.failedToGetSceneDetails
            );
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (isEdit) {
            fetchSceneDetail();
        } else {
            form.setFieldsValue({
                createType: 'precise',
                robotTimbre: 1,
                robotTimbreConfig: 'aishuo',
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEdit]);

    return (
        <div className="create-role">
            <Form
                form={form}
                labelCol={{ span: 4 }}
                wrapperCol={{ span: 16 }}
                onFinish={handleSubmit}
                className="create-role-form"
            >
                {/* 创建类型 */}
                <Form.Item
                    label={
                        /* 创建类型 */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                            .edit.createType
                    }
                    name="createType"
                >
                    <Radio.Group>
                        <Radio value="precise">
                            {/* 精准创建 */}
                            {
                                UdeskLocales['current'].pages.coach.templateManage.roleManage.edit
                                    .accurateCreation
                            }
                        </Radio>
                    </Radio.Group>
                </Form.Item>

                {/* 角色名称 */}
                <Form.Item
                    label={
                        /* 角色名称 */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                            .edit.roleName
                    }
                    name="name"
                    required
                >
                    <Input
                        placeholder={
                            /* 请输入 */ UdeskLocales['current'].pages.coach.templateManage
                                .roleManage.edit.pleaseEnter
                        }
                        maxLength={40}
                        showCount
                    />
                </Form.Item>

                {/* 性别 */}
                <Form.Item
                    label={
                        /* 性别 */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                            .edit.gender
                    }
                    name="robotTimbre"
                >
                    <Radio.Group onChange={(e) => setRobotTimbre(e.target.value)}>
                        <Radio value={1}>
                            {/* 男 */}
                            {
                                UdeskLocales['current'].pages.coach.templateManage.roleManage.edit
                                    .male
                            }
                        </Radio>
                        <Radio value={0}>
                            {/* 女 */}
                            {
                                UdeskLocales['current'].pages.coach.templateManage.roleManage.edit
                                    .female
                            }
                        </Radio>
                    </Radio.Group>
                </Form.Item>

                {/* 音色 */}
                <Form.Item
                    label={
                        /* 音色 */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                            .edit.timbre
                    }
                    name="robotTimbreConfig"
                >
                    <Radio.Group>
                        {robotTimbreConfig.map((item) => (
                            <Radio value={item.value}>{item.label}</Radio>
                        ))}
                    </Radio.Group>
                </Form.Item>

                {/* 自由描述 */}
                <Form.Item
                    label={
                        /* 自由描述 */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                            .edit.freeDescription
                    }
                    name="desc"
                    required
                >
                    <Input.TextArea
                        placeholder={
                            /* 根据您的陪练目标角色情况输入相应的描述，例如TA的性格特征、沟通风格、职位和工作单位、痛点、现使用的是什么产品、现处于什么环境、有哪些可能的异议等。提供的描述越清晰，所构建的角色则会越准确、越具体 */ UdeskLocales[
                                'current'
                            ].pages.coach.templateManage.roleManage.edit
                                .enterTheCorrespondingDescriptionAccordingToYourPartnersTargetRoleSuchAsTAsPersonalityCharacteristicsCommunicationStylePositionAndWorkUnitPainPointsWhatProductsAreCurrentlyUsedWhatEnvironmentAreCurrentlyInPlaceAndWhatPossibleObjectionsAreThereEtcTheClearerTheDescriptionProvidedTheMoreAccurateAndSpecificTheRoleWillBeBuilt
                        }
                        rows={6}
                        style={{ width: 800 }}
                    />
                </Form.Item>

                {/* 客户画像 */}
                <Form.Item
                    label={
                        /* 角色标签 */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                            .edit.roleTags
                    }
                    name="customerTags"
                >
                    <UserTagsSelect handleOriginalNodes={handleOriginalNodes} />
                </Form.Item>

                {/* 备注 */}
                <Form.Item
                    label={
                        /* 备注 */ UdeskLocales['current'].pages.coach.templateManage.roleManage
                            .edit.remarks
                    }
                    name="remark"
                >
                    <Input
                        placeholder={
                            /* 请输入 */ UdeskLocales['current'].pages.coach.templateManage
                                .roleManage.edit.pleaseEnter
                        }
                        maxLength={40}
                        showCount
                    />
                </Form.Item>

                {/* 操作按钮 */}
                <Form.Item className="form-actions" wrapperCol={{ span: 16, offset: 4 }}>
                    <Space>
                        <Button onClick={handleCancel}>
                            {/* 取消 */}
                            {
                                UdeskLocales['current'].pages.coach.templateManage.roleManage.edit
                                    .cancel
                            }
                        </Button>
                        <Button loading={loading} type="primary" htmlType="submit">
                            {isEdit
                                ? /* 保存 */ UdeskLocales['current'].pages.coach.templateManage
                                      .roleManage.edit.save
                                : /* 创建 */ UdeskLocales['current'].pages.coach.templateManage
                                      .roleManage.edit.create}
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>
    );
};

export default CreateRole;
